import { createContext } from "react";
import { createStore, type StoreApi } from "zustand";

import type { TrackedCompany, TrackedUser, TrackingAdapter } from "./vendor/TrackingAdapter";

export type TrackingContextData = {
  user: TrackedUser;
  company: TrackedCompany;
};

export type TrackingState = {
  data: TrackingContextData | null;
  trackingAdapter: TrackingAdapter;
};

export type TrackingZustandStore = StoreApi<TrackingState>;

const noopTrackingAdapter: TrackingAdapter = {
  initialize: () => {},
  onEvent: () => {},
  onLogin: () => {},
  onPageChange: () => {},
  clearWebStorage: () => {},
};

export const TrackingContext = createContext<TrackingZustandStore>(
  createStore<TrackingState>(() => ({
    data: null,
    trackingAdapter: noopTrackingAdapter,
  }))
);
